import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import mutations from './mutations'
import getters from './getters'
import actions from './actions'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const persistState = document.location.href.indexOf('/trials/create') > -1
if (! persistState) {
  window.localStorage.removeItem('vuex')
}

const store = new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
  plugins: persistState ? [createPersistedState()] : [],
})

export default store



// WEBPACK FOOTER //
// ./resources/js/store/index.js